var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackMicrophoneIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 5C13.625 3.27411 12.2259 1.875 10.5 1.875C8.77411 1.875 7.375 3.27411 7.375 5V10C7.375 11.7259 8.77411 13.125 10.5 13.125C12.2259 13.125 13.625 11.7259 13.625 10V5Z",
    stroke: "#A2C357",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.25V18.75",
    stroke: "#A2C357",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 10C16.75 11.6576 16.0915 13.2473 14.9194 14.4194C13.7473 15.5915 12.1576 16.25 10.5 16.25C8.8424 16.25 7.25269 15.5915 6.08058 14.4194C4.90848 13.2473 4.25 11.6576 4.25 10",
    stroke: "#A2C357",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackMicrophoneIcn);
export default __webpack_public_path__ + "static/media/feedback_microphone_icn.4112d3bc210651c0ce866dbe6600ba98.svg";
export { ForwardRef as ReactComponent };